import { ArrowRightIcon } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { programRoute } from '../../ClientRoutes';
import { CompletedProgram } from '../../ProgramStore/Types';
import { Link } from '../../Resource/Types';
import { T } from '../../Translations';
import {
  ProgramCard,
  programCardButtonClassName,
  ProgramCardActions,
  ProgramCardBody,
  ProgramCardFooter,
  ProgramCardHeader,
  ProgramCardTitle,
} from '../Dashboard/ProgramCard';
import ProgramCardTeam from '../Dashboard/ProgramCard/ProgramCardTeam';
import ProgramOutcomePanel from '../Dashboard/ProgramCard/ProgramOutcomePanel';

interface Props {
  programDetail: CompletedProgram;
  links: ReadonlyArray<Link>;
}

const CompletedProgramOverview: React.FC<Props> = ({ programDetail, links }) => (
  <ProgramCard data-test-completed-program={true}>
    <ProgramCardHeader links={links} programInstanceKind={programDetail.programInstanceKind} />
    <ProgramCardTitle title={programDetail.title} />
    <ProgramCardBody>
      <ProgramOutcomePanel programDetail={programDetail} />
      <ProgramCardActions>
        <RouterLink
          to={programRoute(programDetail.id)}
          className={programCardButtonClassName}
          data-testid="program-overview-link"
          data-intercom-target="dashboard-graduated-program-overview-button"
        >
          <T kind="Overview" />
          <ArrowRightIcon size="sm" color="inherit" />
        </RouterLink>
      </ProgramCardActions>
    </ProgramCardBody>
    <ProgramCardFooter>
      <ProgramCardTeam programId={programDetail.id} />
    </ProgramCardFooter>
  </ProgramCard>
);

export default observer(CompletedProgramOverview);
